import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFound from '../../../not-found';
import NoConversationPage from '../../../../components/messaging/default-conversation';
import ConversationPage from './[id]/conversation';
import ConversationsList from 'components/messaging/conversations-list';

export const DesktopMessagingRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<NoConversationPage />} />
      <Route path="/:id" element={<ConversationPage />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export const MobileMessagingRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/:id" element={<ConversationPage mobileMode />} />
      <Route path="*" element={<ConversationsList />} />
    </Routes>
  );
};
